import { createSlice } from '@reduxjs/toolkit';
import { all } from 'redux-saga/effects';

interface InitialState {
  isPmsReady: boolean;
  isPmsOrder: boolean;
  command: string | null;
  pmsData: any | null;
}

const initialState: InitialState = {
  isPmsReady: false,
  isPmsOrder: false,
  command: null,
  pmsData: null,
};

const slice = createSlice({
  name: 'pms',
  initialState,
  reducers: {
    pms_ready: (state, { payload }) => {
      state.isPmsReady = payload;
    },
    pms_order: (state, { payload }) => {
      state.isPmsOrder = payload;
    },
    pms_command: (state, { payload }) => {
      state.command = payload;
    },
    pms_data: (state, { payload }) => {
      state.pmsData = payload;
    },
  },
});

export const actions: any = slice.actions;

export function* pmsSaga() {
  yield all([]);
}

export default slice.reducer;
